export function initGalleryBlocks() {
	const blocks = document.querySelectorAll('[data-gallery-block]');
	if (!blocks.length) {
		return;
	}

	blocks.forEach((block) => {
		initGalleryBlock(block);
	});
}

function initGalleryBlock(block) {
	const triggers = Array.from(block.querySelectorAll('[data-gallery-trigger]'));
	const lightbox = block.querySelector('[data-gallery-lightbox]');
	const image = block.querySelector('[data-gallery-image]');
	const thumbsContainer = block.querySelector('[data-gallery-thumbs]');
	const prevButton = block.querySelector('[data-gallery-prev]');
	const nextButton = block.querySelector('[data-gallery-next]');
	const closeControls = Array.from(block.querySelectorAll('[data-gallery-close]'));

	if (!triggers.length || !lightbox || !image || !prevButton || !nextButton || !thumbsContainer) {
		return;
	}

	const items = triggers
		.map((trigger) => ({
			full: trigger.getAttribute('data-gallery-full') || '',
			thumb: trigger.getAttribute('data-gallery-thumb') || '',
			alt: trigger.getAttribute('data-gallery-alt') || '',
		}))
		.filter((item) => item.full !== '');

	if (!items.length) {
		return;
	}

	let currentIndex = 0;
	const thumbs = [];

	const render = () => {
		const current = items[currentIndex];
		if (!current) {
			return;
		}

		image.setAttribute('src', current.full);
		image.setAttribute('alt', current.alt);

		thumbs.forEach((thumb, index) => {
			thumb.classList.toggle('is-active', index === currentIndex);
		});

		const activeThumb = thumbs[currentIndex];
		if (activeThumb && typeof activeThumb.scrollIntoView === 'function') {
			activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
		}
	};

	const open = (index) => {
		currentIndex = Math.max(0, Math.min(index, items.length - 1));
		render();
		lightbox.hidden = false;
		document.body.style.overflow = 'hidden';
	};

	const close = () => {
		lightbox.hidden = true;
		image.setAttribute('src', '');
		image.setAttribute('alt', '');
		document.body.style.overflow = '';
	};

	const goTo = (step) => {
		currentIndex = (currentIndex + step + items.length) % items.length;
		render();
	};

	const buildThumbs = () => {
		thumbsContainer.innerHTML = '';

		items.forEach((item, index) => {
			const button = document.createElement('button');
			button.type = 'button';
			button.className = 'gallery-lightbox__thumb';
			button.setAttribute('aria-label', `Open image ${index + 1}`);

			const thumbImage = document.createElement('img');
			thumbImage.src = item.thumb || item.full;
			thumbImage.alt = item.alt;
			thumbImage.loading = 'lazy';

			button.appendChild(thumbImage);
			button.addEventListener('click', () => {
				currentIndex = index;
				render();
			});

			thumbsContainer.appendChild(button);
			thumbs.push(button);
		});
	};

	buildThumbs();

	triggers.forEach((trigger, index) => {
		trigger.addEventListener('click', () => {
			open(index);
		});
	});

	prevButton.addEventListener('click', () => {
		goTo(-1);
	});

	nextButton.addEventListener('click', () => {
		goTo(1);
	});

	closeControls.forEach((control) => {
		control.addEventListener('click', close);
	});

	document.addEventListener('keydown', (event) => {
		if (lightbox.hidden) {
			return;
		}

		if (event.key === 'Escape') {
			close();
		}

		if (event.key === 'ArrowLeft') {
			goTo(-1);
		}

		if (event.key === 'ArrowRight') {
			goTo(1);
		}
	});
}
